const DTF = new Intl.DateTimeFormat('en-GB', {
	day: '2-digit',
	month: 'short',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	hourCycle: 'h23',
});

/** Format an ISO timestamp as "02.Aug 2026 12:25" (local time). */
export function fmtDateTime(iso: string): string {
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return iso;
	const p: Record<string, string> = {};
	for (const { type, value } of DTF.formatToParts(d)) p[type] = value;
	return `${p.day}.${p.month} ${p.year} ${p.hour}:${p.minute}`;
}
